import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { tableFilterTypes, CHANGE_TABLE_FILTERS, performerActions } from './performers.era';
import { Exhibitor } from 'globals/store/exhibitors.data';
import { Ranking } from 'globals/store/events.data';
import { makeMapFromListOfObjectsAndKey } from 'globals/helpers/helpers';
import { createFeature, createFeatureSelector, createReducer, on } from '@ngrx/store';
import { eventsActions } from './events.era';

export interface ExhibitorsState extends EntityState<Exhibitor> {
  exhibitorFilterType: string
  standTypes: { [id:string]: Ranking }
  exhibitorTypes: { [id:string]: Ranking }
}

const getDefaultExhibitorsState = ():ExhibitorsState => ({
  ids: [],
  entities: {},
  exhibitorFilterType: tableFilterTypes.NoFilters,
  standTypes: {},
  exhibitorTypes: {}
})

export const adapter = createEntityAdapter<Exhibitor>()
export const makeInitialState = (): ExhibitorsState => adapter.getInitialState(getDefaultExhibitorsState())

export const exhibitorsReducer = createReducer(
  {...makeInitialState()},
  on(eventsActions.loadEvent, (state, { payload }) => {
    const changedState = adapter.upsertMany(Object.values(payload.exhibitors), state)
    const newState = { ...changedState }
    console.log({ changedState, newState })
    newState.standTypes = !payload.standTypes ? {} : makeMapFromListOfObjectsAndKey(payload.standTypes, 'id')
    newState.exhibitorTypes = makeMapFromListOfObjectsAndKey(payload.exhibitorTypes, 'id')
    return newState
  }),
  on(eventsActions.unloadEvent, (state) => ({ ...makeInitialState() })),
  on(performerActions.changeTableFilters, (state, { filterType }) => ({ ...state, exhibitorFilterType: filterType })) 
)

export const exhibitorsFeature = createFeature({
  name: 'exhibitors',
  reducer: exhibitorsReducer,
});

export const exhibitorsStateSelector = createFeatureSelector<ExhibitorsState>(exhibitorsFeature.name)
